import type { LocalDatabase } from '../core/types';
import type { BodyMeasurementRecord } from '~/powersync/generated/schema';
import type { QueryBuilderSpec } from '~/powersync/types';

export const BodyMeasurementQueries = {
  /**
   * Every measurement a user has, newest first. Feeds both the current-weight
   * display and the trend view. Ordered by `measuredAt` then `createdAt` so a
   * skewed/future-dated device clock can't out-rank a later real reading — the
   * server-receipt order (`createdAt`) breaks ties.
   */
  listByUser: (userId: string): QueryBuilderSpec<BodyMeasurementRecord> => ({
    createQuery: (db: LocalDatabase) =>
      db
        .selectFrom('BodyMeasurement')
        .selectAll()
        .where('userId', '=', userId)
        .where('deletedAt', 'is', null)
        .orderBy('measuredAt', 'desc')
        .orderBy('createdAt', 'desc'),
    queryKey: ['bodyMeasurement', 'listByUser', userId],
  }),

  /** The single most-recent measurement — the user's current weight/composition. */
  latest: (userId: string): QueryBuilderSpec<BodyMeasurementRecord> => ({
    createQuery: (db: LocalDatabase) =>
      db
        .selectFrom('BodyMeasurement')
        .selectAll()
        .where('userId', '=', userId)
        .where('deletedAt', 'is', null)
        .orderBy('measuredAt', 'desc')
        .orderBy('createdAt', 'desc')
        .limit(1),
    queryKey: ['bodyMeasurement', 'latest', userId],
  }),
};
